import { useEffect, useState } from 'react';
import { useMarkets } from '@/state/markets';

const SEEN_KEY = 'nasdaq.one:first-time-hint:seen:v1';

/**
 * One-shot tip that fires on first ever session, when the player has done
 * absolutely nothing yet (no fills, no orders). Single line, dismissable.
 * Saved in its own localStorage key so it never shows again — survives
 * even a save reset.
 */
export function FirstTimeHint() {
  const recentFills = useMarkets((s) => s.recentFills);
  const openOrders = useMarkets((s) => s.openOrders);
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(SEEN_KEY) === '1'; } catch { return false; }
  });

  // Auto-dismiss after the player makes their first interaction
  useEffect(() => {
    if (recentFills.length > 0 || openOrders.length > 0) {
      dismiss();
    }
  }, [recentFills.length, openOrders.length]);

  // Hide after 30 seconds even if untouched
  useEffect(() => {
    if (hidden) return;
    const t = setTimeout(dismiss, 30_000);
    return () => clearTimeout(t);
  }, [hidden]);

  function dismiss() {
    setHidden(true);
    try { localStorage.setItem(SEEN_KEY, '1'); } catch { /* private mode */ }
  }

  if (hidden) return null;
  return (
    <button
      onClick={dismiss}
      className="fixed bottom-20 left-1/2 z-[60] -translate-x-1/2 max-w-[90vw] rounded-md border border-[var(--accent-primary)] bg-[var(--bg-elevated)] px-4 py-2 text-mono-xs text-[var(--text-primary)] shadow-2xl backdrop-blur-md hover:bg-[var(--bg-surface)]"
      title="dismiss"
    >
      <span className="text-[var(--accent-primary)] font-bold">tip ·</span>{' '}
      click a ticker on the left to load it · <kbd className="text-[var(--accent-primary)]">B</kbd> buy · <kbd className="text-[var(--accent-primary)]">S</kbd> sell · <kbd className="text-[var(--accent-primary)]">?</kbd> all keys
    </button>
  );
}
